import React, { useEffect, useState } from 'react'
import { BreadCrumbsAndTitle } from '../../components/generics/BreadCrumbsAndTitle'
import { AlertsInformativos } from '../../components/generics/AlertsInformativos'
import { Divider, Grid } from '@mui/material'
import { mtDividerUpTable, paddingCardsTables } from '../../commons'
import { alertInformativo } from '../../commons/texts'

import {
  Box,
  Button,
  Typography,
  Paper,
} from "@mui/material";
import { styled } from '@mui/material/styles';
import { Form, Formik } from 'formik'
import { CrearCamposOrdenesServicios } from '../../components/campos-ordenes-servicios/crear/CrearCamposOrdenesServicios'
import { closeSessionGlobal, hasPemissions } from '../../commons/utils'
import { useDispatch, useSelector } from 'react-redux'
import { storeCreateParameter } from '../../store/parameters'
import validationSchema from '../../components/campos-ordenes-servicios/formModels/crear/validationSchema'
import formInitialValues from '../../components/campos-ordenes-servicios/formModels/crear/formInitialValues'
import createCampoOsFormModel from '../../components/campos-ordenes-servicios/formModels/crear/createCampoOsFormModel'
import { getAllQuotationFieldRedux, storeCreateCamposOrdenesDeServicios } from '../../store/ordenes-de-servicios'
import { ICampoOrdenServicio } from '../../commons/interfaces'
import { CreateDialogCategoriaCotizacion } from '../../features/categoria-cotizacion/modals/CreateDialogCategoriaCotizacion'




interface QuotationField {
  id?: number;
  fieldName: string;
  fieldLabel: string;
  fieldType: string;
  isRequired: boolean;
  options?: string;
}

const fieldTypes = [
  "string",
  "number",
  "date",
  "boolean",
  "time",
  "select",
  "json",
];



export const CamposOrdenesServicio = () => {


    // USE DISPATCH 
    const dispatch = useDispatch();

    

    // REDUX
    const { status }:any  = useSelector( (state:any) => state.loading );
    const { camposOrdenesDeServicio }:any  = useSelector( (state:any) => state.ordenesDeServicio );
    const { categoriaCotizacionesList }:any  = useSelector( (state:any) => state.categoriaCotizacion );

    const isLoading = status === 'checking';

    const [percentaje, setPercentaje] = React.useState(0);
    const [open, setOpenModal] = useState(false);

    const [messagesAlerts, setMessagesAlerts] = React.useState<any>([]);
    const [modalSessionExpired, setModalSessionExpired] = React.useState<boolean>(false);

    
    const [alert_snack, setAlertSnack] = React.useState(false);
    const [msgSnack, setMsgSnack] = React.useState({
        msg: '',
        status: 'success'
    });

    const [fields, setFields] = useState<QuotationField[]>([]);
    const [newField, setNewField] = useState<QuotationField>({
        fieldName: "",
        fieldLabel: "",
        fieldType: "string",
        isRequired: false,
        options: "",
    });



    // DATA MODEL 
    const { formId, formField } = createCampoOsFormModel;
    
    // VALIDATION SCHEMA 
    const currentValidationSchema = validationSchema[0];



     // CONST STYLES 
      const Div = styled('div')(({ theme }) => ({
        ...theme.typography.button,
        backgroundColor: 'wheat',
        padding: theme.spacing(8),
        textAlign: 'center'
      }));


  useEffect(() => {
    getData();
  }, []);
  



  const getData = async() => {


    const havePermissions = await hasPemissions('modulo.thumano', 'modulo.parametros', 'create');


    if( !havePermissions ){

      await validateLsPermissions('No tienes pemisos para (Listar) campos ordenes de servicio.');

      return false;

    }



    const response = await dispatch( getAllQuotationFieldRedux() );

    const result = await validateResponseCreate(response, ' (Listar Ordenes Servicio) ');



    if (!result) {
        return false;
    }


    
    if (response.ok) {
      
      const message:any = {
        msg: response.message,
        status: 'success'
      };
    
      await setMsgSnack(message);
      await setAlertSnack(true);

    }
  }






  const _handleSubmit = async(values:any, actions:any) => {     
    
  
    const havePermissions = await hasPemissions('modulo.thumano', 'modulo.parametros', 'create');


    if( !havePermissions ){

      await validateLsPermissions('No tienes pemisos para (Crear) campos ordenes de servicio.');

      return false;

    }

    actions.setSubmitting(true);

    const response = await dispatch( storeCreateCamposOrdenesDeServicios(values, setPercentaje) );

    const result = await validateResponseCreate(response, ' (Crear Ordenes Servicio) ');



    if (!result) {
        return false;
    }


    
    if (response.ok) {
      
      const message:any = {
        msg: response.message,
        status: 'success'
      };
    
      await setMsgSnack(message);
      await setAlertSnack(true);
  
      actions.resetForm();

    }
  
      
  
  
  
  
  }



  const validateLsPermissions = async(message:string) => {

    const errors:any = {
      msg: message,
      status: 'error'
    };
  
    await setMsgSnack(errors);
    await setAlertSnack(true);
  
  
  }


  const validateResponseCreate = async(response:any, textActionConcat: string) => {
          
          
        if (  response.code == 401  ) {
          await localStorage.removeItem('lastSelectedQypht');
          await closeSessionGlobal();
          setModalSessionExpired(true);
          return false;
        }
  
      
        // 403 NO TIENE PERMISSO PARA REALIZAR ESA ACCION 
        if (!response.ok && response.code == 403 ) { 
  
        
          const errors:any = {
            msg: response.errors[0]+' '+textActionConcat,
            status: 'error'
          };
        
          await setMsgSnack(errors);
          await setAlertSnack(true);
  
        
          return false;
          
        }
  
  
        // 403 EL DATO YA SE ENCUENTRA REGISTRADO
        if (!response.ok && response.code == 409 ) { 
      
          const errors:any = {
              msg: response.errors[0]+' '+textActionConcat,
              status: 'error'
          };
          
          await setMsgSnack(errors);
          await setAlertSnack(true);
  
          return false;
        }
  
        
        // 400 ERROR EN DATOS ENVIADOS MAYORMENTE PROPIEDAD INVALIDA O MAL FORMATEADO 
        if (!response.ok && response.code == 400 ) { 
  
          const errors:any = [];
  
          response.errors.forEach( (element:any) => {
              
              errors.push({
                type: 'error',
                text: element
              })
          });
  
            
          setMessagesAlerts(errors);
          return false;
  
        }
  
        return true;
      
    } 



    const getFieldTypeName = (type: string): string => {
      switch (type) {
        case "text":
          return "Texto";
        case "number":
          return "Número";
        case "date":
          return "Fecha";
        case "select":
          return "Selección";
        default:
          return "Tipo desconocido";
      }
    };


    const openModal = async() => {
 
        const havePermissionsCreate = await hasPemissions("modulo.thumano", "modulo.parametros", "create");
       
        if (!havePermissionsCreate) {
          await validateLsPermissions("No tienes pemisos para (Crear) parametros.");
          return false;
        }
    
        setOpenModal(true);


    }


    const handleCloseDialog = () => {
      setOpenModal(false);
    };

  return (
    <>

        <CreateDialogCategoriaCotizacion open={open} handleCloseDialog={handleCloseDialog} />


        <BreadCrumbsAndTitle
          title="Campos ordenes de servicio" 
          mainModule="ordenes de servicio"
          parent="Campos ordenes de servicio"
          action="" />

          <div style={{ display: "flex", justifyContent: "end" }}>
            <Button variant="contained" sx={{ marginBottom: 3 }} onClick={openModal}>
                  Crear Categoria
            </Button>
          </div>

        <AlertsInformativos type={'info'} title={'info'} content={alertInformativo.camposOrdenesServicios} /> 
        <Divider sx={{ marginBottom: mtDividerUpTable }}/>

              
        
         <Box  sx={{ marginTop: paddingCardsTables }}>
     


   

      <Grid container spacing={2}>
  {/* FORMULARIO - COLUMNA IZQUIERDA */}
  <Grid size={7}>
   
    <div style={{ position: 'sticky', top: 62, zIndex: 10 }}>
        <Typography variant="h5" mb={2}>
        Crear Campos de Cotización
      </Typography>
      <Grid container spacing={2}>
        <Formik
          initialValues={formInitialValues}
          validationSchema={currentValidationSchema}
          onSubmit={_handleSubmit}
        >
          <Paper sx={{ p: 2, mb: 3 }}>
            <Form id={formId}>
              <CrearCamposOrdenesServicios formField={formField} />
              <Button
                variant="contained"
                color="primary"
                type="submit"
                sx={{ mt: 2 }}
                loading={isLoading}
              >
                Agregar Campo
              </Button>
            </Form>
          </Paper>
        </Formik>
      </Grid>
    </div>
  </Grid>

  {/* CAMPOS EXISTENTES - COLUMNA DERECHA */}
  <Grid size={5}>
    <Typography variant="h6">Campos existentes:</Typography>

    {camposOrdenesDeServicio.length > 0 ? (
      camposOrdenesDeServicio.map((field: ICampoOrdenServicio) => (
        <Paper
          key={field.id}
          sx={{
            p: 2,
            mt: 2,
            borderLeft: '5px solid #1976d2',
            backgroundColor: '#f5f5f5',
          }}
        >
          <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
            {field.fieldLabel}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Tipo de campo: <strong>{getFieldTypeName(field.fieldType)}</strong>
          </Typography>
          <Typography
            variant="body2"
            color={field.isRequired ? 'error' : 'text.secondary'}
          >
            {field.isRequired
              ? 'Este campo es obligatorio'
              : 'Este campo es opcional'}
          </Typography>

          {Array.isArray(field.options) && field.options.length > 0 && (
            <>
              <Typography variant="body2" sx={{ mt: 1 }} color="text.secondary">
                Opciones disponibles:
              </Typography>
              <ul style={{ marginTop: 4, marginBottom: 0, paddingLeft: 20 }}>
                {field.options.map((option: string, index: number) => (
                  <li key={index}>
                    <Typography variant="body2">{option}</Typography>
                  </li>
                ))}
              </ul>
            </>
          )}
        </Paper>
      ))
    ) : (
      <Div>{"No hay campos disponibles..."}</Div>
    )}
  </Grid>
</Grid>



    </Box>



    </>
  )
}





